import { memo } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface MemoViewerDialogProps {
  memoToShow: { nickname: string; memo: string };
  onClose: () => void;
}

/**
 * 고객 메모 읽기 전용 뷰어 다이얼로그.
 * 호출부에서 `{memoToShow && <MemoViewerDialog .../>}`로 마운트되므로 memoToShow는 non-null.
 * state(memoToShow)는 Home이 소유.
 */
export const MemoViewerDialog = memo(function MemoViewerDialog({ memoToShow, onClose }: MemoViewerDialogProps) {
  return (
    <Dialog open={!!memoToShow} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{memoToShow.nickname}님의 메모</DialogTitle>
        </DialogHeader>
        <div className="py-4 whitespace-pre-wrap">
          {memoToShow.memo}
        </div>
        <DialogFooter>
          <Button onClick={() => onClose()}>닫기</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
});
